import { render } from "./DetalharBlocoAvaliacao.vue?vue&type=template&id=7486b3dd&scoped=true"
import script from "./DetalharBlocoAvaliacao.vue?vue&type=script&lang=js"
export * from "./DetalharBlocoAvaliacao.vue?vue&type=script&lang=js"

import "./DetalharBlocoAvaliacao.vue?vue&type=style&index=0&id=7486b3dd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7486b3dd"]])

export default __exports__